import React, {useEffect, useState} from "react";
import Strings from "../../../config/Strings";
import {TigerButton} from "../../../global/tiger-button/TigerButton";
import {Spinner} from "react-bootstrap";
import GlobalConstants from "../../../config/GlobalConstants";
import {useHistory, useLocation} from "react-router";
import {authCheck} from "../../../util/authCheck";
import {InfoModal} from "../../../global/ConfirmationModal";
import {CreateResource} from "../../../api/SpineClient";

export default function McDonaldsRedemptionPreview({ email, setToken }) {

    const [loading, setLoading] = useState(false);
    const coupon = JSON.parse(sessionStorage.getItem('ls.mcdonalds'))
    const history = useHistory();
    const [showError, setShowError] = useState(false);
    const [errorText, setErrorText] = useState(null);
    const location = useLocation();

    //ROUTING
    useEffect(() => {
        if (!authCheck()) {
            history.push("/" + GlobalConstants.APP_PATH + "mcdonalds/authenticate#mcdonalds-authentication-register");
        }

        if (coupon == null || coupon.code == null || coupon.pin == null) {
            history.push("/" + GlobalConstants.APP_PATH + "mcdonalds");
        }

        if (location !== undefined && location.hash !== "") {
            const element = document.getElementById(location.hash);
            if (element) {
                element.scrollIntoView({behavior: "smooth", block: "center"});
            }
        }
    }, [history, coupon, location]);

    if (coupon == null || coupon.code == null || coupon.pin == null) {
        history.push("/" + GlobalConstants.APP_PATH + "mcdonalds");
    }

    if (!authCheck()) {
        history.push("/" + GlobalConstants.APP_PATH + "mcdonalds/authenticate#mcdonalds-authentication-register");
    }

    const redeem = async () => {
        setLoading(true);

        //Submit the response
        let response = await CreateResource('api/purchases/coupons/submit-order',{code: coupon.code, pin: coupon.pin});

        if (response.error) {
            console.log("error while redemption of coupon: " + response.message);
            setErrorText(Strings.MCDONALDS_REDEMPTION_UNKNOWN_ERROR);
            setShowError(true);
            setLoading(false);
            return;
        }

        window.scrollTo(0, 0);
        history.push("/" + GlobalConstants.APP_PATH + "mcdonalds/success");

        setLoading(false);
    }

    //Rendering
    return (
        <>
            <div className="mcdonalds-container">
                <div className="mcdonalds-header-overlay">
                    <div>
                        <img src={"https://cdn.tigerbooks.de/promotion/mcdonalds/header.png"}
                             alt={"header"}/>
                    </div>
                </div>
                <div className="mcdonalds-info" id="#mcdonalds--preview" style={{textAlign: "center"}} dangerouslySetInnerHTML={{__html: Strings.MCDONALDS_PREVIEW_INFO.replace("{0}", email)}} />

                <div className="mcdonalds-form-container">
                    <div className="mcdonalds-form">
                        <div className="d-flex justify-content-center" style={{marginBottom: "2rem"}}>
                            <TigerButton className="small-height" variant="red" type="button" onClick={() => redeem()} disabled={loading}>
                                {loading ?
                                    <Spinner animation="border" />
                                    :
                                    Strings.MCDONALDS_REDEEM_BUTTON}
                            </TigerButton>
                        </div>
                        <div dangerouslySetInnerHTML={{__html: Strings.MCDONALDS_SWITCH_ACCOUNT_INFO.replace("{0}", email)}} />
                        <div className="d-flex justify-content-center" style={{marginBottom: "2rem"}}>
                            <TigerButton className="small-height mt-3" variant="blue" type="button" onClick={() => setToken({})}>
                                {Strings.MCDONALDS_CHANGE_ACCOUNT_BUTTON}
                            </TigerButton>
                        </div>
                    </div>
                </div>
            </div>
            <InfoModal
                title={Strings.REGISTER_UNKNOWN_ERROR_TITLE}
                text={errorText}
                show={showError}
                onHide={() => setShowError(false)} />
        </>
    )
}